import React from "react";
import { SelectBox, TextBox, Popover, List } from "devextreme-react";
import DevExpressDropdownButton from "../../Shared/DevExpressDropdownButton";

const SelectItem = (props) => {
    const name = props.Nombre !== undefined ? props.Nombre.toString().toUpperCase() : props.Nombre

    return (
        <div className='company-name-select'>
            <span className='nombre'
                  title={props && props.Nombre}>{name}{' - '}{props && props.RutEmpresa}</span>
            {/* <span className="rut" title={props && props.RutEmpresa}>{props && props.RutEmpresa}</span> */}
            {props.selected && (
                <span className='check-empresa'>
        <i className='achs-icon'>c</i>
      </span>
            )}
        </div>
    );
};

class SelectEmpresas extends React.PureComponent {
  componentDidUpdate = (prevProps) => {
    if ((!this.props.isHovering && prevProps.isHovering) ||
      (!this.props.show && prevProps.show)) {
      this.props.open && this.props.handleOpenClose(false);
    }
  }

  render() {
    const {
      handleChange,
      dataSource,
      value,
      handleOpenClose,
      show,
    } = this.props;
    return (
      <div className="col-sm-6">
        <SelectBox
          visible={show}
          id="selectEmpresa_PM"
          displayExpr="Nombre"
          onInitialized={(e) => {
            e.component._options.openOnFieldClick = false;
          }}
          valueExpr="RutEmpresa"
          placeholder="Empresas"
          dataSource={dataSource}
          value={value}
          fieldComponent={(props) => (
            <div id="empresa_select_empresa" className="select-empresas" onClickCapture={() => handleOpenClose(true)}>
              <TextBox readOnly visible={false} defaultValue={props.Nombre} />
              <SelectItem className="select-item" {...props} />
              <DevExpressDropdownButton />
            </div>
          )}
        />
        <Popover
          position={{ my: "bottom", offset: "0 -18" }}
          target="#selectEmpresa_PM"
          className="popover-menu col-sm-3 Popover_selectEmpresas"
          animation={{
            show: {
              type: "pop",
              duration: 0,
            },
          }}
          visible={this.props.open}
          onHiding={() => handleOpenClose(false)}
        >
          <div onMouseEnter={this.props.onMouseEnter} className="col-sm-12">
            <List
              className="company-select-list"
              dataSource={dataSource}
              searchEnabled
              noDataText="Sin empresas"
              searchExpr={["RutEmpresa", "Nombre"]}
              searchEditorOptions={{
                placeholder: "Buscar ",
              }}
              onItemClick={(event) => {
                handleOpenClose(false);
                handleChange(event, event.itemData);
              }}
              itemRender={(props) =>
                <SelectItem {...props} selected={props && props.RutEmpresa === this.props.value} />
              }
            />
          </div>
        </Popover>
      </div>
    );
  }
}

export default SelectEmpresas;
